import { FC, Fragment, MouseEvent, useState } from "react";
import { Avatar, IconButton, Menu, useMediaQuery, useTheme } from "@mui/material";

import { useUser } from "@dzambalaorg/provider-user";
import type { IUser } from "@framework/types";

import { SectionsMenu } from "./SectionsMenu";

export interface ISectionsProps {
  onMenuItemClick?: () => void;
}

export const Sections: FC<ISectionsProps> = props => {
  const {
    onMenuItemClick = () => {
      return;
    },
  } = props;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const [anchor, setAnchor] = useState<Element | null>(null);

  const user = useUser<IUser>();

  const handleMenuOpen = (event: MouseEvent): void => {
    if (isMd) {
      return;
    }
    setAnchor(event.currentTarget);
  };

  const handleMenuClose = (): void => {
    setAnchor(null);
    onMenuItemClick();
  };

  if (!user.isAuthenticated()) {
    return null;
  }

  return (
    <Fragment>
      <IconButton
        disabled={isMd}
        aria-owns={anchor ? "material-appbar" : undefined}
        aria-haspopup="true"
        data-testid="OpenSiteMenuButton"
        onClick={handleMenuOpen}
        color="inherit"
      >
        <Avatar
          sx={{ color: "#ffffff", backgroundColor: "rgba(0, 0, 0, 0.15)" }}
          alt={user.profile.displayName}
          src={user.profile.imageUrl}
        >
          {user.profile.displayName?.substring(0, 1)}
        </Avatar>
      </IconButton>
      <Menu id="material-appbar" anchorEl={anchor} open={!!anchor} onClose={handleMenuClose}>
        <SectionsMenu handleMenuClose={handleMenuClose} />
      </Menu>
    </Fragment>
  );
};
